module.exports = __webpack_public_path__ + "static/img/2_1.304dcef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fujiFilm/2_1.jpg
// module id = on/r
// module chunks = 0